import {createI18n} from 'vue-i18n';
// import es from '../locale/es.json';
// import de from '../locale/de.json';
// import nl from '../locale/nl.json';
// import jp from '../locale/jp.json';
// import en from '../locale/en.json';


function loadLocaleMessages () {
  const locales = require.context('./locale', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export default createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
});
